import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, createVNode as _createVNode } from "vue"

type columnsType = {
  // 属性名
  prop: string
  // 列名
  label: string
  // 宽度，可以是字符串或数字
  width?: string | number
  // 是否自定义
  isCustom?: boolean,
  // 固定位置，可以是'right'、'left'或'center'
  fixed?: 'right' | 'left' | 'center'
  // 对齐方式，可以是'center'、'left'或'right'
  align?: 'center' | 'left' | 'right',
  // 最小宽度，可以是字符串或数字
  minWidth?: string | number
  //排序
  isSort?:boolean,
  // 排序参数
  sortKey?:string,
  border?:boolean
}

// 定义props，用于接收配置和列的参数

export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
    data: {},
    columns: {}
  },
  emits: ['onSort'],
  setup(__props: any, { emit: __emit }) {

// 定义一个columnsType类型，用于描述表格列的属性
const props = __props

const emits=__emit


// 排序
function onSort({prop, order,column}:Record<string, any>) {
  emits('onSort', {prop, order,key:column.columnKey})
}

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_table, {
      data: _ctx.data,
      border: _ctx.item?.border,
      style: {"width":"100%"},
      "row-key": "id",
      onSortChange: onSort
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.columns, (item) => {
          return (_openBlock(), _createBlock(_component_el_table_column, {
            prop: item.prop,
            sortable: item.isSort?'custom':false,
            label: item.label,
            "min-width": item.minWidth,
            width: item.width,
            fixed: item.fixed,
            align: item.align||'center',
            "column-key": item.sortKey
          }, _createSlots({ _: 2 }, [
            (item.isCustom)
              ? {
                  name: "default",
                  fn: _withCtx((scope) => [
                    _renderSlot(_ctx.$slots, item.prop, {
                      row: scope.row,
                      column: scope.column,
                      index: scope.$index
                    })
                  ]),
                  key: "0"
                }
              : undefined
          ]), 1032, ["prop", "sortable", "label", "min-width", "width", "fixed", "align", "column-key"]))
        }), 256))
      ]),
      _: 3
    }, 8, ["data", "border"])
  ]))
}
}

})